export enum Asset {

    Niw = 'NIW',
    Waio = 'WAIO'

}